import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	showInSidebar: {
		id: 'navigation.global-side-navigation.more-menu.show-in-sidebar.label',
		description:
			'Label on Show in sidebar button in the side navigation. Button appears in place of the More menu when items are being dragged.',
		defaultMessage: 'Show in sidebar',
	},
});
